module.exports = __webpack_public_path__ + "img/goods9_2.c9f175e3.jpg";